import {
  addScript
} from '../utilities'
import { getBookSVG } from '../utils/get-svgs'

export async function getBookPreviewLink (bookData) {
  let previewLink = ''
  let readExcerptLabel = 'Read an Excerpt'
  if (bookData.languages.read_excerpt) readExcerptLabel = bookData.languages.read_excerpt
  if (!bookData.formats || !bookData.formats.length) {
    return
  }
  let eBookIsbn = ''
  bookData.formats.forEach((format) => {
    if (format.format.code === 'DG') {
      eBookIsbn = format.isbn
    }
  })

  if (!window.theme.settings.bookDetailsSettings || !window.theme.settings.bookDetailsSettings.book_preview_method) {
    return
  }

  const bookPreviewMethod = window.theme.settings.bookDetailsSettings.book_preview_method

  if (eBookIsbn && bookPreviewMethod === 'aerio') {
    const bookSvg = getBookSVG()
    const aerioReplaceText = `<span>${readExcerptLabel}</span>${bookSvg}`
    previewLink = `<li class='aerio_preview' data-isbn='${eBookIsbn}' data-social='1' data-retail='1'
    data-newtab='1' data-link_text='${aerioReplaceText}' data-emailcap='0'></li>`
    addScript('https://aeriopr01prodpreviews.blob.core.windows.net/aerio-blob-preview/embedded_js/embedded_js.js', { type: 'text/javascript' })
  } else if (bookPreviewMethod === 'google_books') {
    previewLink = await getGooglePreviewURl(readExcerptLabel, bookData.formats)
  }

  return previewLink
}

const getGooglePreviewURl = async (linkLabel, formats) => {
  const previewRequest = async (isbn) => {
    const data = await fetch(
      `https://www.googleapis.com/books/v1/volumes?q=isbn:${isbn}`, {
        method: 'GET',
        mode: 'cors'
      }
    )
    const json = await data.json()
    if (!json || !json.items || !json.items.length) {
      return null
    }
    const { accessInfo } = json.items[0]
    if (accessInfo && (accessInfo.accessViewStatus === 'SAMPLE' || accessInfo.accessViewStatus === 'FULL_PUBLIC_DOMAIN')) {
      return json
    }
    return null
  }

  let book
  for (const format of formats) {
    const bookJson = await previewRequest(format.isbn)
    if (bookJson) {
      book = bookJson.items[0]
      break
    }
  }

  if (!book) return
  const bookSvg = getBookSVG()
  return `<li><a href="http://books.google.com/books?id=${book.id}&printsec=frontcover" title="${linkLabel}" target="_blank"><span>${linkLabel}</span>${bookSvg}</a></li>`
}
